import { render, staticRenderFns } from "./TableFieldsContainer.vue?vue&type=template&id=ccb45d20&scoped=true&"
import script from "./TableFieldsContainer.vue?vue&type=script&lang=js&"
export * from "./TableFieldsContainer.vue?vue&type=script&lang=js&"
import style0 from "./TableFieldsContainer.vue?vue&type=style&index=0&id=ccb45d20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb45d20",
  null
  
)

export default component.exports